import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import User from "../ui/users/User";
import UsersList from "../ui/users/UsersList";
import UserDetails from "../ui/users/UserDetails";
import UserEdit from "../ui/users/UserEdit";
import UserRoleUpdate from "../ui/users/UserRoleUpdate";

const UserRoutes = (
  <Route
    path={AppSections.USERS}
    element={
      <ProtectedRoute>
        <User />
      </ProtectedRoute>
    }
  >
    <Route path="/users/" element={<UsersList />} />
    <Route path="role-request" element={<UserRoleUpdate />} />
    <Route path=":id/view" element={<UserDetails />} />
    <Route path=":id/edit" element={<UserEdit />} />
  </Route>
);

export default UserRoutes;